module.exports = __webpack_public_path__ + "img/ertiga.bee83706.svg";